<template>
	<div id="app" v-touch:tap='onClick' :class="{'screensaving': screensaver}">
		<div class="header hide-landscape">
			<WFBuildingLogo/>
			<div class="clock-container">
				<div class="clock hide-mobile">
					<ClockComponent format="HH:mm" />
				</div>
				<div class="date hide-mobile">
					<CurrentDate/>
				</div>
			</div>
		</div>
		<div class="content-container">
			<div class="pages-container">
				<WFTabs ref="tabs" :activeTab="currentTab" @tabChanged="tabChanged">
					<WFTab name="map">
						<div class="page map-area-container" :class="{'map-search-visible': searchVisible, 'lower': lower}">
							<WFMap project="535bac2dfd5221e3ffcf56dce77833b5" @poiClicked="onMapPOIClick" @onTouch="onMapClick" @loaded="mapLoaded" ref="map"/>
							<div class="map-floors-menu">
								<WFFloorsMenu @clicked="floorChange" :currentFloor="currentFloor"/>
							</div>
						</div>
						<div id="poi-popup" ref="poiPopup" v-show="isPOIPopupVisible()" :class="['items-' + popupPOIs.length]">
							<div class="poi-popup-content" v-if="popupPOIs.length > 0">
								<div class="poi-popup-poi" :class="{'always': popupPOI.isAlwaysVisible()}" v-for="popupPOI in popupPOIs" :key="popupPOI.id">
									<label class="title">{{popupPOI.getName(language)}}</label>
									<label class="phone" v-if="popupPOI.phone">{{popupPOI.phone}}</label>
									<label class="desc" v-if="popupPOI.isAlwaysVisible()" v-html="popupPOI.getDescription(language) || ''"></label>
								</div>
							</div>
							<div class="pin-down"></div>
						</div>
						<WFBanner template="default" container="advertisements" class="small-banners"></WFBanner>
					</WFTab>
					<WFTab name="osakonnad">
						<div class="page osakonnad" :class="{'map-search-visible': searchVisible, 'lower': lower}">
							<div class="block">
								<WFScrollableArea>
									<div class="block-content">
										<h1 data-translation-element="osakonnad">Osakonnad</h1>
										<ContactMenu :showPOIs="true" :parent=2 :order="false">
											<template v-slot:poi="slotProps">
												<div class="poi-image">
													<div class="image"><img :src="slotProps.poi.getIconUrl()"/></div>
												</div>
												<div class="poi-body">
													<h2>{{slotProps.poi.getName(language)}}</h2>
													<label>{{slotProps.poi.getDescription(language) || ''}}</label>
													
													<label>{{slotProps.poi.phone}}</label>
													<a>{{slotProps.poi.email}}</a>
													<button class="room" v-if="slotProps.poi.getNode()">
														<label @click="showPOI(slotProps.poi)">Näita teekonda</label>
														<icon name="arrow"/>
													</button>
													<button class="wheelchair" v-if="slotProps.poi.getNode()">
														<label @click="showPOIDisabled(slotProps.poi)">Näita teekonda</label>
														<icon name="wheelchair"/>
													</button>
												</div>
											</template>
											<template v-slot="groupProps">
												<label>{{groupProps.group.getName(language)}}</label>
												<icon name="arrow"/>
											</template>
										</ContactMenu>
									</div>
								</WFScrollableArea>
							</div>
						</div>
					</WFTab>
					<WFTab name="kontaktid">
						<div class="page kontaktid" :class="{'map-search-visible': searchVisible, 'lower': lower}">
							<div class="block">
								<WFScrollableArea>
									<div class="block-content">
										<h1 data-translation-element="contacts">Kontaktid</h1>
										<ContactMenu :showPOIs="true" :parent=1 :order="false">
											<template v-slot:poi="slotProps">
												<div class="poi-image">
													<div class="image"><img :src="slotProps.poi.getIconUrl()"/></div>
												</div>
												<div class="poi-body">
													<h2>{{slotProps.poi.getName(language)}}</h2>
													<label>{{slotProps.poi.getDescription(language) || ''}}</label>
													
													<label>{{slotProps.poi.phone || ''}}</label>
													<label>{{slotProps.poi.opening_hours || ''}}</label>
													<a>{{slotProps.poi.email}}</a>
													<button class="room" v-if="slotProps.poi.getNode()">
														<label @click="showPOI(slotProps.poi)">Ruum {{slotProps.poi.room_id}}</label>
														<icon name="arrow"/>
													</button>
												</div>
											</template>
											<template v-slot="groupProps">
												<label>{{groupProps.group.getName(language)}}</label>
												<icon name="arrow"/>
											</template>
										</ContactMenu>
									</div>
								</WFScrollableArea>
							</div>
						</div>
					</WFTab>
					<WFTab name="bussiajad">
						<div class="page bussiajad" :class="{'map-search-visible': searchVisible, 'lower': lower}">
							<div class="block">
								<WFScrollableArea>
									<WFBrowser src="https://timetables.3dwayfinder.com/app/pzukl2jia2qcdxipkp2gef21/bustimes/" :resetPage="false"/>
								</WFScrollableArea>
							</div>
						</div>
					</WFTab>
					<WFTab name="otsing">
						<WFSearch noResultsText="Tulemusi ei ole" :showRoomID="true" :limit="10" @clicked="onSearchClick" :showDescription="true" ref="search"></WFSearch>
					</WFTab>
					<WFTab name="screensaver">
						<div class="screensaver" v-show="screensaver" @click="hideBanner()">
							<div class="banner-container">
								<WFBanner template="default" container="screensaver" class="hide-portrait" @hasbanners="hasBanners"></WFBanner>
								<WFBanner template="default" container="screensaver-portrait" class="hide-landscape" @hasbanners="hasBanners"></WFBanner>
							</div>
						</div>
					</WFTab>
				</WFTabs>
			</div>
			
		</div>
		<div class="menus-container ">
			<WFFlagsMenu :showTitle="false" :showFlag="false" labelType="code"/>
			<WFBuildingLogo class="hide-portrait"/>
			<div class="page-menu">
				<!--div @click="reset" :class="{'active': currentTab == 'screensaver'}">Screensaver</div-->
				<div @click="changeTab('map')" :class="{'active': currentTab == 'map'}" data-translation-element="majajuht">Majajuht</div>
				<div @click="changeTab('kontaktid')" :class="{'active': currentTab == 'kontaktid'}" data-translation-element="contacts">Kontaktid</div>
				<div @click="changeTab('osakonnad')" :class="{'active': currentTab == 'osakonnad'}" data-translation-element="osakonnad">Osakonnad</div>
				<!--div @click="changeTab('koolibuss')" :class="{'active': currentTab == 'koolibuss'}">Koolibuss</div-->
				<div @click="changeTab('bussiajad')" :class="{'active': currentTab == 'bussiajad'}" data-translation-element="bustimes">Bussiajad</div>
				<div @click="changeTab('otsing')" :class="{'active': currentTab == 'otsing'}" data-translation-element="search">Otsing</div>
			</div>
			<div class="clock-container hide-portrait">
				<div class="clock hide-mobile">
					<ClockComponent format="HH:mm" />
				</div>
				<div class="date hide-mobile">
					<CurrentDate/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* global wayfinder */

import { WFMap, WFFloorsMenu, WFZoomMenu, WFTabs, WFTab, WFGroupsMenu, WFScrollableArea, WFPOI, WFBanner, WFBuildingLogo, WFBrowser, WFSearch, WFFlagsMenu} from '@3dwayfinder/wayfinder-vue-components'
import { ClockComponent } from 'vue-clock'
import { mapState } from 'vuex';
import POIOverlay from "./components/POIOverlay.vue";
import POI from "./components/POI.vue";
import YAH from "./components/YAH.vue";
import CurrentDate from "./components/CurrentDate.vue";
import Koolitused from "./components/Koolitused.vue";
import ContactMenu from "./components/ContactMenu.vue";

export default {
	name: 'app',
	components: {
		WFMap,
		WFFloorsMenu,
		WFZoomMenu,
		WFGroupsMenu,
		ClockComponent,
		WFTabs,
		WFTab,
		WFScrollableArea,
		WFPOI,
		WFBanner,
		WFBuildingLogo,
		WFBrowser,
		WFSearch,
		WFFlagsMenu,
		POIOverlay,
		POI,
		YAH,
		CurrentDate,
		Koolitused,
		ContactMenu
	},
	data () {
		return {
			lastClick: false,
			landscape: false,
			screensaver: true,
			hasScreensaver: false,
			busTimesOpen: false,
			menuActive: true,
			showLabel: false,
			searchActive: false,
			floorsMenuCurrent: null,
			filteredMenuCurrent: null,
			currentVisible: false,
			lower: false,
			poiPopupVisible: false,
			popupPOIs: [],
			popupPOIfloor: null,
			poiX: 0,
			poiY: 0,
			currentTab: 'map'
		}
	},
	mounted () {
		this.resize();

		window.onresize = () => {
			this.resize();
		}
	},
	computed: {//yahLogo
		...mapState('wf', ['searchVisible', 'maxInActivity', 'mobile', 'pois', 'currentGroup', 'currentFloor', 'currentPOI', 'language']),
		isFiltered() {
			return this.currentGroup || this.floorsMenuCurrent;
		}
	},
	methods: {
		onClick () {
			clearTimeout(this.lastClick);
			this.$refs['map'].run();
			this.lastClick = setTimeout(() => { // Start screensaver
				if(!this.mobile) {
					this.reset();
					if (this.$refs['map']) {
						this.$refs['map'].reset();
					}
				}
			}, this.maxInActivity * 1000);
			return false;
		},
		onMapClick () {
			this.$wayfinder.setDehighlightOverlay(false);
			this.$wayfinder.clearHighlights();
			this.$wayfinder.clearDisplaying();
			this.onClick();
		},
		onGroupMenuClick (group) {
			if (group != this.currentGroup) {
				this.$store.dispatch('wf/SET_CURRENT_GROUP', group);
				this.$store.dispatch('wf/SET_FILTERED_POIS', group.pois);
				this.$refs["scrollarea"].reset();
			}
			else {
				this.$store.dispatch('wf/SET_CURRENT_GROUP', false);
				this.$store.dispatch('wf/SET_FILTERED_POIS', this.pois);
				this.$refs["scrollarea"].reset();
			}

		},
		onFloorMenuClick (floor) {
			if(this.floorsMenuCurrent !== floor) {
				this.floorsMenuCurrent = Object.freeze(floor);
				this.$store.dispatch('wf/SET_FILTERED_POIS', floor.pois);
			}
			else {
				this.floorsMenuCurrent = null;
				this.$store.dispatch('wf/SET_FILTERED_POIS', this.pois);
			}
		},
		resetMenu () {
			this.$store.dispatch('wf/SET_CURRENT_GROUP', null);
			this.floorsMenuCurrent = null;
			this.$store.dispatch('wf/SET_FILTERED_POIS', this.pois);
		},
		onPOIClick (poi) {
			this.filteredMenuCurrent = Object.freeze(poi);
			if(poi.getNode()) {
				this.$wayfinder.showFloor(poi.getNode().floor);
				this.$wayfinder.clearHighlights();
				this.$wayfinder.setHighlights([poi]);
				this.setPopupPOIs(poi);
			}
			
		},
		setPopupPOIs (poi) {
			
			if (poi && poi.getNode()) {
				var room_id = poi.room_id && poi.room_id != "" ? poi.room_id : "poi_" + poi.id; // temporary room
				var room = this.$wayfinder.rooms[room_id];
				this.popupPOIs = Object.freeze( room.pois);
				this.popupPOIfloor =  poi.getNode().floor;
				this.currentVisible = true;
				this.showPOIPopup(poi);
			}
		},
		onMapPOIClick (poi) {
			console.log('onMapPOIClick', poi);
			let actualPOI = poi;
			if(poi.getNode()) {
				this.$wayfinder.clearHighlights();
				this.$wayfinder.setHighlights([poi]);
				this.$wayfinder.setDisplaying([poi]);	
				this.setPopupPOIs(poi);			
			}

			this.$store.dispatch('wf/SET_CURRENT_POI', actualPOI); 
		},

		showPOIPopup (poi) {
			let position = this.$wayfinder.getScreenPosition(poi);	
			let offset =  (this.$wayfinder.settings.getFloat("poi.2d.icon-size", 24, poi) - 24) / 2;
			this.$refs.poiPopup.style.left = position[0] + "px";
			this.$refs.poiPopup.style.top = position[1] - offset + "px";
			this.poiPopupVisible = true;
		},

		showPOI (poi) {
			if (poi && poi.getNode()) {
				console.log('poi', poi);
				this.changeTab('map');
				this.$wayfinder.showFloor(poi.getNode().floor);
				this.poiPopupVisible = false;
				setTimeout(() => {
					console.log('highlight', poi)
					this.$wayfinder.clearHighlights();
					this.$wayfinder.setHighlights([poi]);
					this.$wayfinder.setDisplaying([poi]);
					this.$wayfinder.showPath(poi.getNode(), poi);
				}, 300);
				
			}
		},
		showPOIDisabled (poi) {
			if (poi && poi.getNode()) {
				this.changeTab('map');
				this.$wayfinder.showFloor(poi.getNode().floor);
				this.poiPopupVisible = false;
				setTimeout(() => {
					console.log('highlight', poi)
					this.$wayfinder.clearHighlights();
					this.$wayfinder.setHighlights([poi]);
					this.$wayfinder.setDisplaying([poi]);
					this.$wayfinder.showPath(poi.getNode(), poi, {"ignoreTypes": ["escalator", "stairs"]});
				}, 300);
				
			}
		},
		showShortcut (nearest) {
			if (nearest && nearest.getNode().floor != this.$wayfinder.getCurrentFloor()) {
				this.$wayfinder.showFloor(nearest.getNode().floor);
			}

			this.$wayfinder.setDehighlightOverlay(true);
			this.$wayfinder.clearHighlights();
			this.$wayfinder.update();
		
			this.poiPopupVisible = false;
		},
		hidePOIPopup () {
			this.poiPopupVisible = false;
		},
		closePOI () {
			this.currentVisible = false;
			this.$store.dispatch('wf/SET_CURRENT_POI', null);
		},
		onSearchClick (poi) {
			if(poi.getNode()) {
				this.changeTab("map");
				
				this.$wayfinder.showFloor(poi.getNode().floor);
				this.$wayfinder.setHighlights([poi]);
				this.$wayfinder.showPath(poi.getNode(), poi);
			}
		},
		onSearchPOIClick (poi) {
			if (poi) {
				this.onPOIClick(poi);
				// this.$wayfinder.showPath(poi.getNode())
				this.$wayfinder.clearHighlights();
				this.$wayfinder.setHighlights([poi]);
			}
		},
		showPath (poi) {
			if (poi) {
				this.$wayfinder.showPath(poi.getNode());
				this.$store.dispatch('wf/SET_CURRENT_POI', null);
				this.$wayfinder.clearHighlights();
				this.currentVisible = false;
				console.log('showPath', this.currentVisible)
				// this.$wayfinder.setHighlights([poi]);
			}
		},
		reset () {
			this.changeTab('screensaver');
			this.$store.dispatch('wf/SHOW_SEARCH', false);
			this.$store.dispatch('wf/SET_RESET');
			this.menuActive = false;
			this.lower = false;
			this.screensaver = true;
			this.currentVisible = false;
			this.popupPOIs = [];
			if (this.$refs['map']) {
				this.$refs['map'].pause();
			}
		},
		resize () {
			let _l = window.matchMedia("(orientation: landscape)");
			let _pm = window.matchMedia("(max-height: 1024px) and (orientation: portrait)");
			let _lm = window.matchMedia("(max-width: 1024px) and (orientation: landscape)");
			this.landscape = _l ? _l.matches : false;
			let mobile = (_pm ? _pm.matches : false) || (_lm ? _lm.matches : false);
			this.$store.dispatch('wf/SET_LANDSCAPE', this.landscape);
			this.$store.dispatch('wf/SET_MOBILE', mobile);
		},
		doSomething () {},
		changeTab (tab) {
			this.currentTab = tab;
		},
		hideBanner () {
			console.log('hideBanner');
			this.screensaver = false;
			this.$refs['map'].run();
			this.$wayfinder.resize();
			this.changeTab('map');
		},
		mapLoaded () {
			this.screensaver = false;
			this.$refs['map'].run();

			this.$refs.search.addLayout("et", {
				'name': "Estonian",
				'local_name': "Eesti",
				'lang': "et",
				'keys': {
					"default": [
						["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
						["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "\u00FC", "\u00F5"],
						["a", "s", "d", "f", "g", "h", "j", "k", "l", "\u00F6", "\u00E4"],
						["z", "x", "c", "v", "b", "n", "m", {'key': "&#171;", 'action': ["backspace"], cls: "delete"}],
						[{"key": " ", "cls": "key_spacebar"}]
						]
				}
			});

			this.$refs.search.changeLayout("et");

			this.$wayfinder.events.on("map-update", () => {
				if (this.poiPopupVisible && this.popupPOIs.length > 0) {
					this.showPOIPopup(this.popupPOIs[0]);
				}	
			});

			this.$wayfinder.events.on("floor-change", (floor) => {
				if (this.poiPopupVisible && this.popupPOIs.length > 0) {
					if (this.popupPOIfloor == floor) {
						this.showPOIPopup(this.popupPOIs[0]);
					}
				}
				else {
					this.poiPopupVisible = false;
				}
			});
		},
		hasBanners (has) {
			this.hasScreensaver = has;
		},
		tabChanged () {
			this.menuActive = true;
		},
		floorChange (floor) {
			this.$store.dispatch('wf/SET_CURRENT_FLOOR', floor);
			this.$wayfinder.showFloor(floor);
		},
		toggleAccessibility () {
			this.lower = !this.lower;
		},
		isPOIPopupVisible () {
			return (this.$wayfinder && this.popupPOIs.length > 0 && this.poiPopupVisible && this.popupPOIfloor == this.$wayfinder.getCurrentFloor() && this.currentVisible)
		},
		getGroupNames (poi) {
			if (poi) {
				groupProps.group.getName(language)
			}
			return "";
		}
		
	}
};
</script>

<style lang="less">
	@import 'theme/styles';
	@import 'theme/responsive';

	.scrollable {
		position: relative;
	}
</style>
